/* template */
<template minapp="mpx" xlang="wxml"><from-item :isShow="(isShow)" :isRequiredShow="(isRequiredShow)" label="邮箱地址" :innerValue="(innerValue)" :nameTips="(nameTips)"><es-field placeholder="用于接受12306的邮件，选填" :value="innerValue" mpxModelEvent="input" @mpxModel='__model("innerValue", $event, ["value"], undefined)' @blur="onBlur" slot="input" class="es-field-email"/></from-item></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m1e77131c"}'>
.es-field-email
    /deep/ .es-field__inner
      width: auto;
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m1e77131c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./email.mpx.js?isComponent&outputPath=components%2Femail1e77131c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./email.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Femail1e77131c%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m1e77131c"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/email1e77131c/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'from-item':getComponent(require("./from-item.mpx?isComponent&outputPath=components%2Ffrom-item141a5554%2Findex")),'es-cell':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/cell/index.mpx?isComponent&outputPath=components%2Findex1902b88c%2Findex")),'es-field':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/field/index.mpx?isComponent&outputPath=components%2Findex69975464%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
